/*
* @Author: chillylight
* @Date:   2019-10-17 09:27:48
* @Last Modified by:   chillylight
* @Last Modified time: 2020-08-25 14:47:42
*/
import 'select2/dist/css/select2.min.css';
import _comMeds from '@src/assets/js/common.js';
import _corpus from '@src/assets/js/server/corpus-server.js';
import _term from '@src/assets/js/server/term-server.js'; 
import _tran from '@src/assets/js/server/tran-server.js'; 
import FormData from 'form-data'; 
import '@src/assets/js/table.js';
import 'jquery-form';
import './index.scss';
import 'select2';

// const fromLan = require("@src/assets/json/lan.json");
var fromLan = '';
var toLan = '';

var page = {
    data: {
       lanId: '',
       selectionIds: [], //保存选中id
       left_from_lan: '', 
       left_to_lan: '',
       lan_create_time: '',
       publicType: '',
       ku_length: '',
       leftId: '',  //原文id
       rightId: '', //译文id
       initFromVal:1,
       initToVal:2
    },
    init: function() {
       this.onLoad();
       this.bindEvent();
    },
    onLoad: function() {
       this.getCorLibList();
       this.getLanOptions();
    },
    bindEvent: function() {
        var _this = this;
        
        // 点击创建语言
        $('body').on('click', '.create-lan', function(e){
           _this.createLanTip();

           e.preventDefault();
           e.stopPropagation();
        })

        // 点击创建语料
        $('body').on('click', '.add-corpus', function(e){
            _this.addCorpusTip();

            e.preventDefault();
            e.stopPropagation();
        })

        // 点击左侧删除语言
        $('body').on('click', '.set .del-item', function(e){
            var del_lan1 = $(this).parents('li').find(".lan1").text();
            var del_lan2 = $(this).parents('li').find(".lan2").text();
            var del_id = $(this).parents('li').data("id");
            _this.delTip(del_lan1, del_lan2, del_id);
            e.stopPropagation();
        })

        //点击左侧编辑语言
        $('body').on('click', '.set', function(e){
            $(this).children('.del-item').show();

            e.preventDefault();
            e.stopPropagation();
        })
        
        //隐藏设置
        $('body').on('click', function(e){
            $('.set .del-item').hide();
        })

        // 点击切换语言
        $('body').on('click', '.corpus-nav li', function(e){
            $("#searchStr").val('');
            $(this).siblings().removeClass("active");
            $(this).addClass("active");

            _this.data.left_from_lan = $(this).children('.lan1').text();
            _this.data.left_to_lan = $(this).children('.lan2').text();
            _this.data.lan_create_time = parseInt($(this).attr('data-time'));
            _this.data.lanId = $(this).attr('data-id');

            _this.data.selectionIds = [];
            $('.choosenum').hide();
            $('.daochu').addClass('active').siblings('.del-select').addClass('active');

            _this.changeItem();
        })

        // 编辑语料
        $('body').on('click', '.row-edit', function(){
           let cid = $(this).attr('data-id');
           /*let ori = $(this).attr('data-ori');
           let tra = $(this).attr('data-tra');*/

            let subData = {
                corId:cid
            };
            _corpus.getCorpusById(subData,function(res){
                _this.editCorpus(res.original,res.translated,cid);
            },function(res){
                _comMeds.autoCloseAlert("获取预料失败！");
            })
        })

       // 删除语料
       $('body').on('click', '.row-cancel', function(){
           let cid = $(this).attr('data-id');
           _this.delItemTip(cid);
       })

        // 点击搜索
        $('#searchBtn').on('click', function() {
            $('#mainGrid').DataTable().destroy();
             _this.getCorpusListByLibId();
        })

        // 回车搜索
        $('#searchStr').keydown(function(e) {
            if(e.keyCode == "13" || e.which == 13) {
                $('#mainGrid').DataTable().destroy();
                _this.getCorpusListByLibId(); 
            } else {
                return;
            }
        })

        // 点击全选
        $('body').on('click', '.total-check', function(){
            let is_check_all = $(".total-check").prop("checked");
			let choose_id = '';

			if (is_check_all) {
				$(".check-item input").prop("checked",true);
				$.each($(".check-item input"),function(i,item){
					choose_id = $(item).data("id");
					if ($.inArray(choose_id,_this.data.selectionIds)!=-1) {
						_this.data.selectionIds.splice(choose_id, 1);
					}else{
						_this.data.selectionIds.push(choose_id);
					}
				})
			}else{
				$.each($(".check-item input"),function(i,item){
					choose_id = $(item).data("id");
					let id_index = $.inArray(choose_id,_this.data.selectionIds);
					if (id_index != -1) {
						_this.data.selectionIds.splice(id_index, 1);
					}else{
						_this.data.selectionIds.push(choose_id);
					}
				})
				$(".check-item input").prop("checked",false);
			}
            _this.getCheckbedBoxId();
        })
       
        // 单个点击复选框
        $('body').on('click', '.check-item input', function(){
			let id = $(this).data("id");
			let is_choose = $.inArray(id,_this.data.selectionIds);

			if (is_choose == '-1') {
				_this.data.selectionIds.push(id);
			}else{
				_this.data.selectionIds.splice(is_choose, 1);
            }

            if( $(".total-check").prop("checked") && !$(this).prop('checked')){
                $(".total-check").prop("checked",false);
            }
            
            _this.getCheckbedBoxId();

		})
        

        // 批量删除
        $('body').on('click', '.del-select', function() {
            if(_this.data.selectionIds < 1) {
                _comMeds.autoCloseAlert('请至少选择一行');
            } else {
                var ids = _this.data.selectionIds.join(',');
                _this.delItemTip(ids);
            }
        })

        // 点击下载模板
        $('body').on('click', '.daochumuban', function(){
            _this.excelFormat();
        })

        // 点击导入语料
        $('body').on('click', '.importCurpus', function(){
            $('.importExcle').click();
        })

        // 导入语料
        $('body').on('change', '.importExcle', function() {
            if(_this.check(this.files[0].name)){
                _this.importCurpus(this.files[0]);
            } else {
                _this.uploadErrorTip();
            }
        })

        // 点击导出
        $('body').on('click', '.daochu', function(){
            if(_this.data.selectionIds < 1) {
                _comMeds.autoCloseAlert('请至少选择一行');
            } else {
                _this.exportCurpus();
            }
        })

        // 点击导出全部
        $('body').on('click', '.daochu-all', function(){
            _this.exportAllCurpus();
        })

        // 点击表格行样式发生变化
        $('body').on('click', '.maintable tbody tr', function() {
            if($(this).children('td:first-child').find('.check-item input').prop('checked')){
                $(this).css({
                    'background-color': '#FAFBFD'
                })
            } else {
                $(this).css({
                    'background-color': '#fff'
                })
            }
        })
        
    },

    // 初始化下拉框
    initSelect: function() {
        // 原文选择框
        let _this = this;
        $('#fromSel').select2({
            data: fromLan,
            minimumResultsForSearch: 1,
            placeholder: "--请选择--",
            width: '140px'
        }).val(_this.data.initFromVal).trigger('change');

        // 译文选择框
        $('#toSel').select2({
            data: toLan,
            minimumResultsForSearch: 1,
            placeholder: "--请选择--",
            width: '140px'
        }).val(_this.data.initToVal).trigger('change');
    },

    createLanTip: function() {
       var _this = this;
       if(_comMeds.isLogin()){
        var str = '<div class="lan_tip_box create-corpus-box">'
            + '<div class="select-item">' 
            + '<span class="title"><i>*</i>语言方向: </span>'
            + '<select id="fromSel" class="selectpicker"></select>'
            + '<i class="iconfont iconjiantouyou"></i>'
            + '<select id="toSel" class="selectpicker"></select>'
            + '</div>'
            + '</div>'
        _comMeds.zgAlert({
            title: '创建语言',
            width: '550px',
            content: str,
            yesFn: function(e){
                var subData = {
                    fromLanguage: $('#fromSel option:selected').text(),
                    toLanguage: $('#toSel option:selected').text(),
                    publicType: 2
                }
                _corpus.addCorpusLib(subData, function(res){
                    $(".common-shadow-bg").remove();
                    _this.getCorLibList();
                },function(res){
                    _comMeds.autoCloseAlert(res.msg);
                })
            },
            closeFn: function(e){
                $(".common-shadow-bg").remove();
            }
        })

        _this.initSelect();
        _this.data.leftId = $('#fromSel option:selected').val();
        _this.data.rightId = $('#toSel option:selected').val();
        
        $('#fromSel').on('select2:select', function() {
            if(fromLan[$(this).val()].languageCode == toLan[$('#toSel option:selected').val()].languageCode){
                _comMeds.autoCloseAlert('语言不能相同');
                $(this).select2('val', '0');
            }
        })
        $('#toSel').on('select2:select', function() {
            if(toLan[$(this).val()].languageCode == fromLan[$('#fromSel option:selected').val()].languageCode){
                _comMeds.autoCloseAlert('语言不能相同');
                $(this).select2('val', '1');
            }
        })

       } else {
          _comMeds.doLogin();
       }
    },

    // 添加语料弹框
    addCorpusTip: function() {
        var _this = this;
        var str = '<div class="corpus_tip_box">'
                + '<textarea class="before-tran-text" rows="5" placeholder="原文(请以句号、问号、感叹号结束)"></textarea>'
                + '<textarea class="after-tran-text" rows="5" placeholder="译文(请以句号、问号、感叹号结束)"></textarea>'
                + '</div>'
            _comMeds.zgAlert({
                title: '添加语料',
                content: str,
                yesFn:function(e){
                    var before_text = $(".before-tran-text").val().trim();
                    var after_text = $(".after-tran-text").val().trim();
                    if (/(<|>)+/g.test(before_text)) {
                        _comMeds.autoCloseAlert("请勿输入<或>等非法字符");
                        return false;
                    }
                    if (/(<|>)+/g.test(after_text)) {
                        _comMeds.autoCloseAlert("请勿输入<或>等非法字符");
                        return false;
                    }
                    var subData = {
                        ori: before_text,
                        tra: after_text,
                        libId: _this.data.lanId
                    }
                    _corpus.addCorpus(subData, function(res){
                        $(".common-shadow-bg").remove();
                        _this.getCorpusListByLibId();
                    },function(res){
                        _comMeds.autoCloseAlert(res.msg)
                    })
                },
                closeFn:function(e){
                    $(".common-shadow-bg").remove();
                }
            })
    },

    // 删除语料库提示弹框
    delTip: function(del_lan1,del_lan2,del_id) {
        let _this = this;
        var str = '<p style="margin:55px auto;">确认删除「 '+del_lan1+' - '+del_lan2+' 」语料库？删除后不可恢复</p>';
        _comMeds.zgAlert({
            title: '提示',
            content: str,
            noText:'取消',
            yesFn: function(e) {
                var subData = {
                    libId: del_id
                }
                _corpus.deleteCorpusLib(subData, function(res){
                    $(".common-shadow-bg").remove();
                    _this.getCorLibList();
                },function(res){
                    _comMeds.autoCloseAlert(res.msg);
                })
            },
            noFn: function(e) {
                $(".common-shadow-bg").remove();
            },
            closeFn: function(e) {
                $(".common-shadow-bg").remove();
            }
        })
    },

    // 删除语料提示弹框
    delItemTip: function(delId) {
        let _this = this;
        var str = '<p style="margin:55px auto;">确认删除吗？删除后不可恢复</p>';
        _comMeds.zgAlert({
            title: '提示',
            content: str,
            noText:'取消',
            yesFn: function(e) {
                if (!_comMeds.checkDoubleClick()) {
                    return false;
                }
                var subData = {
                    cidList: delId
                }
                _corpus.deleteCorpus(subData, function(res) {
                    _this.data.selectionIds = [];
                    _this.getCheckbedBoxId();
                    $('.choosenum').hide();
                    $('#mainGrid').dataTable().fnDraw(false);
                    $(".common-shadow-bg").remove();
                },function(res){
                    _comMeds.autoCloseAlert(res.msg);
                })
            },
            noFn: function(e) {
                $(".common-shadow-bg").remove();
            },
            closeFn: function(e) {
                $(".common-shadow-bg").remove();
            }
        })
    },

    // 导入语料
    importCurpus: function(file) {
        
        let _this = this;
        let formData = new FormData();
        formData.append("file",file);
        formData.append("libId", _this.data.lanId);
        formData.append("deviceType",'web');
        formData.append("deviceId",_comMeds.getDeviceId());

        var pp = '<div style="width:100%;text-align:center;line-height:24px;">上传中请稍等...<br/>若文件较大时，请多等待些时间</div>';
        var jc = $.dialog({
            title: '',
            boxWidth: '400px',
            useBootstrap: false,
            content: pp,
        }) 

        $.ajax({
            url: _comMeds.getServerUrl('sdoc/excel/importExcelCorpus'),
            type: 'POST',
            dataType: 'json',
            data: formData,
            processData: false, // 不处理数据
            contentType: false, // 不设置内容类型
            success: function(data) {
                if(data.code == 0) {
                    _this.getCorpusListByLibId();
                   if(data.data.errorMsg){
                       _comMeds.autoCloseAlert(data.data.errorMsg);
                   }
                   if(data.data.errorList.length > 0) {
                       var dd = $.dialog({
                           title: '',
                           boxWidth: '400px',
                           useBootstrap: false,
                           content: '<div class="tangchuang-box create-corpus-box"><h3>提示</h3>'
                           + '<div class="text-box">'
                           + '<p style="color: #031B4D;font-size: 16px;">成功个数: ' + data.data.successCount + '</p>'
                           + '<p style="color: #031B4D;font-size: 16px;">失败个数: ' + data.data.errorCount + '</p>'
                           + '<div class="err-table"><table id="errTable" class="maintable hover row-border"></table></div>'
                           + '</div>'
                           + '</div>',
                           onContentReady: function () {
                              $('#errTable').dataTable({
                                autoWidth:false, // 控制Datatables是否自适应宽度
                                info: true, // 控制是否显示表格左下角的信息
                                data: data.data.errorList, //数据
                                lengthChange:false, // 是否允许用户改变表格每页显示的记录数
                                lengthMenu:[5], // 显示几项结果
                                ordering:false, // 是否允许Datatables开启排序
                                serverSide:false, // 是否开启服务器模式
                                stateSave: false, // 保存状态 - 在页面重新加载的时候恢复状态（页码等内容）
                                searching:false, // 是否允许Datatables开启本地搜索
                                columns: [
                                    {
                                        title:"行数",
                                        data: null,
                                        width:'30%',
                                        className:'align-left',
                                        render: function(data, type, row, meta){
                                            return row.row;
                                        }
                                    },
                                    {
                                        title: '错误信息',
                                        data: null,
                                        width: '70%',
                                        className: 'align-center',
                                        render: function(data, type, row, meta){
                                            return row.msg;
                                        }
                                    }
                                ],

                              })
                           }
                       })
                   }
                } else if(data.code == -6300012){
                    _this.uploadErrorTip();
                } else {
                    _comMeds.autoCloseAlert(data.msg);
                }
                $('.importExcle').val(null);
                jc.close();
            },
            error: function(err) {
                $('.importExcle').val(null);
                _comMeds.autoCloseAlert("请求错误");
                jc.close();
                // _this.uploadErrorTip();
            }
        })
    },

    // 导出语料
    exportCurpus: function() {
       let _this = this;
       var gids = _this.data.selectionIds.join(',')
       
       let url = _comMeds.getServerUrl('sdoc/excel/exportCorpusPartByLibId');
       let form =  $("<form style='display:none;' target='' method='post' action="+url+">");
       let input_str = '<input type="hidden" name="deviceType" value="web" />'
                     +'<input type="hidden" name="deviceId" value="'+_comMeds.getDeviceId()+'" />'
                     +'<input type="hidden" name="libId" value="'+_this.data.lanId+'" />'
                     +'<input type="hidden" name="cids" value="'+gids+'" />'

        $("body").append(form);
        form.append(input_str);
        form.submit();
    },

    // 导出全部
    exportAllCurpus: function() {
        let _this = this;
        
        let url = _comMeds.getServerUrl('sdoc/excel/exportCorpusAllByLibId');
       let form =  $("<form style='display:none;' target='' method='post' action="+url+">");
       let input_str = '<input type="hidden" name="deviceType" value="web" />'
                     +'<input type="hidden" name="deviceId" value="'+_comMeds.getDeviceId()+'" />'
                     +'<input type="hidden" name="libId" value="'+_this.data.lanId+'" />'

        $("body").append(form);
        form.append(input_str);
        form.submit();
    },


    // 上传术语格式错误提示框
    uploadErrorTip: function() {
        let _this = this;
        var str = '<p style="margin:55px auto;">你上传的文档格式不符合，请下载附件按翻译狗格式填写后，再上传！</p>';
        _comMeds.zgAlert({
            title: '提示',
            content: str,
            yesText: '下载格式',
            yesFn:function(e){
                _this.excelFormat();
                setTimeout(function(){
                    $(".common-shadow-bg").remove();
                },2500)
            },
            noFn:function(e){
                $(".common-shadow-bg").remove();
            },
            closeFn:function(e){
                $(".common-shadow-bg").remove();
            }
        })
    },

    // 下载模板
    excelFormat: function() {
        let url = _comMeds.getServerUrl('sdoc/excel/exportTempleteCorpys');
        let form = form =  $("<form style='display:none;' target='' method='post' action="+url+">");
        let input_str = '<input type="hidden" name="deviceType" value="web" />'
					  +'<input type="hidden" name="deviceId" value="'+_comMeds.getDeviceId()+'" />';
		$("body").append(form);
		form.append(input_str);
        form.submit();
    },

    // 编辑语料
    editCorpus: function(text1, text2, id) {
        var str = '<div class="corpus_tip_box">'
        + '<textarea class="before-tran-text" rows="5" placeholder="原文(请以句号、问好、感叹号结束)">' + text1 + '</textarea>'
        + '<textarea class="after-tran-text" rows="5" placeholder="译文(请以句号、问好、感叹号结束)">' + text2 + '</textarea>'
        + '</div>'
        _comMeds.zgAlert({
            title: '编辑语料',
            content: str,
            yesFn: function(e) {
                var before_text = $(".before-tran-text").val().trim();
                var after_text = $(".after-tran-text").val().trim();
                if (/(<|>)+/g.test(before_text)) {
                    autoCloseAlert("请勿输入<或>等非法字符");
                    return false;
                }
                if (/(<|>)+/g.test(after_text)) {
                    autoCloseAlert("请勿输入<或>等非法字符");
                    return false;
                }
                var subData = {
                    ori: before_text,
                    tra: after_text,
                    cid: id
                }
                _corpus.updateCoupus(subData, function(res){
                    $('#mainGrid').dataTable().fnDraw(false);
                    $(".common-shadow-bg").remove();
                },function(res){
                    _comMeds.autoCloseAlert(res.msg)
                })
            },
            closeFn: function(e) {
                $(".common-shadow-bg").remove();
            }
        })
    },

    // 显示还未创建语料库
    showEmptyKu: function() {
       $('.kong-content').show();
       $('.corpus-nav').hide();
       $('.right-box').hide();
    },
    

    // 获取语料库语言列表
    getCorLibList: function() {
        let _this = this;
        if(_comMeds.isLogin()) {
            $('.caozuo .btnBox1').show().siblings('.btnBox2').hide();
            _corpus.getCorLibList({}, function(res){
                if(res !== null){
                    _this.showMyListAndContent(res);
                } else {
                    $(".corpus-nav").empty();
                    $(".left-box-header").show();
                    _this.showEmptyKu();
                    $('.create_term').show(); 
                }
            }, function(res) {
                _comMeds.autoCloseAlert(res.msg);
            })
        } else {
          _this.showEmptyKu();
        }
    },

    //渲染我的列表及内容
    showMyListAndContent: function(data) {
        var _this = this;
        var str = '';
        var is_active = '';
        $(".corpus-nav").empty();
        $(".left-box-header").show();
        if(data.length == 0) {
            _this.showEmptyKu();
            $('.create_term').show();
        } else {
            $(".kong-content").hide();
            $(".right-box").show();
            $(".corpus-nav").show();
            var edit_icon = '';
            $.each(data, function(i, item) {
                if(i == 0) {
                    is_active = 'active';
                    _this.data.left_from_lan = item.fromLanguage;
                    _this.data.left_to_lan = item.toLanguage;
                    _this.data.lanId = item.id;
                    _this.data.lan_create_time = item.createTimes;
                } else {
                    is_active = ''
                }

                if(!item.existCor) {
                    edit_icon = '<span class="set">'
                              + '<i class="iconfont iconshezhi"></i>'
                              + '<span class="del-item">删除</span>'
                              +'</span>'
                } else {
                    edit_icon = '';
                }
                str += '<li class="'+is_active+'" data-id='+item.id+' data-time='+item.createTimes+' data-publicType='+item.publicType+'>'
                    + '<span class="lan1">'+item.fromLanguage+'</span>'
                    + '<i class="iconfont iconjiantouyou"></i>'
                    + '<span class="lan2">'+item.toLanguage+'</span>'
                    + edit_icon
                    + '</li>';
            })
            $(".corpus-nav").append(str);
            _this.changeItem();

        }

    },
   
    // 获取我的语料列表
    getCorpusListByLibId: function() {
        let _this = this;
        let matchIdCount = 0;
        
        if ($("#mainGrid").hasClass("dataTable")) {
            $("#mainGrid").dataTable().fnDestroy();
        }

        $('#mainGrid').dataTable({
            autoWidth:false, // 控制Datatables是否自适应宽度
            info: true, // 控制是否显示表格左下角的信息
            lengthChange:true, // 是否允许用户改变表格每页显示的记录数
            lengthMenu:[10,20], // 显示几项结果
            ordering:false, // 是否允许Datatables开启排序
            serverSide:true, // 是否开启服务器模式
            dom: 't<"table-bottom-box clearfix"i<"select-page"l>p>',
            stateSave: false, // 保存状态 - 在页面重新加载的时候恢复状态（页码等内容）
            searching:true, // 是否允许Datatables开启本地搜索
            columns: [
                {
                    data: null,
					title:'<label class="check-box all-check"><input type="checkbox" name="total-check" class="total-check" /></label>',
					width:'4%',
					className:'align-left',
					render: function(data, type, row, meta){
                        var content;
                        if($.inArray(row.id,_this.data.selectionIds) != -1){
                            content = '<label class="check-box check-item">'
                                    +'<input type="checkbox" checked name="single-check" data-id="'+row.id+'" />'
                                    +'</label>';
                            matchIdCount++;
                            if (matchIdCount == 10) {
                                $(".total-check").prop("checked",true);
                            }
                        } else {
                            $(".total-check").prop("checked",false);
                            content = '<label class="check-box check-item">'
                                    +'<input type="checkbox" name="single-check" data-id="'+row.id+'" />'
                                    +'</label>';
                        }
                        return content;
                    }
                },
                {
                    title:"原文",
                    data: 'original',
                    width:'40%',
                    className:'align-left',
                },
                {
                    title:"译文",
                    width:'40%',
                    className:'align-left',
                    data: 'translated' 
                },
                {
                    data: null,
                    title: "操作",
                    width: "16%",
                    className: 'align-left',
                    render: function(data, type, row, meta) {
                        var content = '<span class="row-span row-edit"  data-id="'+row.id+'" style="color:#3F66FF;margin-right:20px;cursor:pointer;">编辑</span>' 
                                    + '<span class="row-span row-cancel"  data-id="'+row.id+'" style="color:#3F66FF;cursor:pointer;">删除</span>'
                        return content;
                    }
                }
            ],
            ajax: function (data, callback, settings) {
                //封装相应的请求参数，这里获取页大小和当前页码
                var pagesize = data.length;//页面显示记录条数，在页面显示每页显示多少项的时候,页大小
                var start = data.start;//开始的记录序号
                var page = (data.start) / data.length + 1;//当前页码
                var subData = {
                    size: pagesize,
                    page:page,
                    libId: _this.data.lanId,
                    queryParam: $('#searchStr').val()
                };

                _corpus.getCorpusListByLibId(subData, function(res,msg){
                    let returnData = {};
                    matchIdCount = 0;
                    if (res.totalSize === 0) {
                        $(".table-bottom-box").hide();
                        var edit_icon = '<span class="set">'
                        + '<i class="iconfont iconshezhi"></i>'
                        + '<span class="del-item">删除</span>'
                        +'</span>'
                        $('.corpus-nav li.active').append(edit_icon);
                    } else {
                        $('.corpus-nav li.active .set').remove();
                    }
                        
                    returnData.recordsTotal = res.totalSize;//totalSize指的是总记录数
                    returnData.recordsFiltered = res.totalSize;//后台不实现过滤功能,全部的记录数都需输出到前端，记录数为总数
                    returnData.data = res.returnList;//返回汽车列表
                    callback(returnData);//这个别忘了！！！
                },function(res){
                    _comMeds.autoCloseAlert(res.msg);
                })
            },
        })
    },

    // 修改语言和时间
    changeItem: function() {
        let _this = this;
        $('.before-lan').text(_this.data.left_from_lan);
        $('.after-lan').text(_this.data.left_to_lan);
        $('#libTime').text(_comMeds.formatTime(_this.data.lan_create_time));
        _this.getCorpusListByLibId();
    },

    getCheckbedBoxId: function() {
        let _this = this;
        if(_this.data.selectionIds.length > 0) {
            $('.choosenum').show();
            $('.choosenum').text('已选中'+ _this.data.selectionIds.length+'条内容')
            $('.btnBox1  .del-select').removeClass('active').siblings('.daochu').removeClass('active');
        } else {
            $('.choosenum').hide();
            $('.btnBox1 .del-select').addClass('active').siblings('.daochu').addClass('active');
        }
        
        if(_this.data.selectionIds.length > 1) {
            $('.row-span').css({
                "color":'#D5D8E9',
                "cursor":'default'
            }).prop('disabled', true)
        } else{
            $('.row-span').css({
                "color":'#3F66FF',
                "cursor":'pointer'
            }).prop('disabled', false)
        }
    },

    // 校验上传的文件是否符合
    check: function(objUrl) {
        var img_url = objUrl.toLowerCase().split('.');
        if (objUrl == "") {
            return false;
        } else {
            if (img_url[img_url.length - 1] == 'xls'
                || img_url[img_url.length - 1] == 'xlsx') {
                return true;
            } else {
                return false;
            }
        }
    },
    // 获取语言
    getLanOptions(){
        let _this = this;
        _tran.getLanguage({},function(res){
            let new_from_lan_arr = [];
            let new_to_lan_arr = [];

            $.each(res.fromList,function(i,item){
                let lan_item = {};
                if (item.languageCode == '' || item.languageCode == 'auto') {
                    return;
                }
                lan_item.id = i;
                lan_item.languageCode = item.languageCode;
                lan_item.text = item.languageName;
                new_from_lan_arr.push(lan_item);
                if (item.languageCode == 'zh') {
                    _this.data.initFromVal = i;
                }

                fromLan = new_from_lan_arr;
            })
            $.each(res.toList,function(i,item){
                let lan_item = {};
                if (item.languageCode == '') {
                    item.languageCode = 0;
                }
                lan_item.id = i;
                lan_item.languageCode = item.languageCode;
                lan_item.text = item.languageName;
                new_to_lan_arr.push(lan_item);
                if (item.languageCode == 'en') {
                    _this.data.initToVal = i;
                }

                toLan = new_to_lan_arr;
            })
        },function(res){
            console.log("获取语言失败");
        })
    }


}

$(function(){
    page.init();
})